// Původní název:		invia.widgets.PopupWindow
//						invia.widgets.PopupWindow.DataTypes
// Původní umístění:	shared/js/widget/invia.widgets.PopupWindow.js
// #CHECKED jthiemel 181220


import $ from 'jquery';
import { DataTypes } from '@invia/web-library/helpers/constants';
import { translate } from '@invia/web-library/helpers/translations';
import AjaxResponse from '@invia/web-library/helpers/ajaxResponse';
import { createMessage } from './userMessages';
// import { initAntiSpamControl } from '../components/antiSpamControl';
import { compensateForScrollbar } from '@invia/web-library/helpers/compensateForScrollbar';
import AjaxForm from './ajaxForm';
import { svgIcon } from './svgIcon';
import { captureAjaxError } from '@invia/web-library/helpers/console';

class PopupWindow {
	constructor (options) {
		this.overlay = null;
		this.window = {
			close: null,
			content: null,
			contentWrap: null,
		};

		this.isOpen = false;
		this.target = null;

		options = options || {};

		options = $.extend({
			width: 600,
			dataType: DataTypes.HTML,
			onOpen: null,
			onLoad: null,
			onClose: null,
			controlElem: null,
			requestData: null,
			closeButton: true,
			disableClosing: false,
		}, options);

		this.width = options.width;
		this.dataType = options.dataType;
		this.requestData = options.requestData;

		this.onOpen = options.onOpen;
		this.onLoad = options.onLoad;
		this.onClose = options.onClose;
		this.closeButton = options.closeButton;
		this.disableClosing = options.disableClosing;

		if (options.controlElem) {
			this.control($(options.controlElem));
		}

		this.ajaxFormProp = null;
		return this;
	}

	control ($elems) {
		var that = this;

		//$elems.on('click', function (e) {
		$('body').on('click', $elems.selector, function(e) {
			e.preventDefault();

			var href = $(this).attr('href');

			if (typeof href == 'undefined' || href == '#' || href == '') {
				throw new Error('href for loading AJAX content is not set');
			}

			that.target = $(this);
			that.openUrl(href);
		});
	}

	openHtml (html) {
		this.open();
		this.window.content.html(html);
		this.handleOnLoad({}, null);

		// TODO: teoreticky muze nastat situace, ze by se pres tuhle funkci zobrazoval AJAX form,
		// pak by to chtelo doresit podporu. Ale beru to tak, ze ten se vzdycky bude nacitat pres openUrl.
	}

	open () {
		$('html').addClass('sk-box-open sk-standard');

		if (!this.isOpen) {
			this.isOpen = true;
			this.handleOnOpen();
			this.overlayShow();
			this.boxShow();
		}

		this.showLoader();

		compensateForScrollbar.init();
	}

	overlayShow () {
		var h = $('body').height();
		this.overlay = $('<div id="sk-box-overlay"></div>').height(h).appendTo($('body'));

		var that = this;

		if (!this.disableClosing) {
			this.overlay.bind('click', function () {
				that.close();
			});
		}
	}

	overlayHide () {
		this.overlay.unbind().remove();
	}

	boxShow () {
		var html =
			'<div id="sk-content">' +
			'<div id="sk-box-desc-wrap">' +
			'<div id="sk-box-desc"></div>' +
			'</div>';
		if (this.closeButton) {
			html +=
				'<a href="#" id="sk-box-close" title="' + translate('close') + '">' +
				'<span class="text">' + translate('close') + '</span>' +
				svgIcon('cross') +
				'</a>';
		}
		html += '</div>';

		this.window.elem = $('<div id="sk-box-window"></div>');
		this.window.elem
			.html(html)
			.appendTo($('body'));

		this.window.close = $('#sk-box-close', this.window.elem);
		this.window.title = $('#sk-box-title', this.window.elem);
		this.window.content = $('#sk-box-desc', this.window.elem);
		this.window.contentWrap = $('#sk-box-desc-wrap', this.window.elem);

		if (!this.disableClosing) {
			this.window.close.bind('click', {that: this}, this.handleClose);
			$(document).bind('keyup', {that: this}, this.handleKeyClose);
		}

		this.boxPosition();
	}

	// Počítání pozice boxu
	boxPosition () {
		var scroll = $('html').scrollTop() || $('body').scrollTop();

		this.window.elem.removeClass('sk-box-window-full').css({
			marginLeft: '-' + this.width / 2 + 'px',
			width: this.width + 'px',
			top: scroll + 'px',
		});

		// Tohle bylo v ThickBoxu, ale moc nevim proc. CSS pro tridu  nejsou definovane..

		// if ($('html').width() > this.width) {
		// 	this.window.elem.removeClass('sk-box-window-full').css({
		// 		marginLeft: '-' + this.width / 2 + 'px',
		// 		width: this.width + 'px',
		// 		top: scroll + 'px'
		// 	});
		// } else {
		// 	this.window.elem.removeAttr('style').css({
		// 		top: scroll
		// 	}).addClass('sk-box-window-full');
		// }
	}

	close () {
		this.isOpen = false;
		this.handleOnClose();
		this.boxHide();
		this.overlayHide();

		$('html').removeClass('sk-box-open');
		$('html').removeClass('sk-standard');

		compensateForScrollbar.destroy();
	}

	handleClose (e) {
		e.data.that.close();
		return false;
	}

	boxHide () {
		this.window.close.unbind();
		$(document).unbind('keyup', this.handleKeyClose);
		this.window.elem.remove();
	}

	// zavření z klávesnice
	handleKeyClose (e) {
		var that = e.data.that,
			key = that.getKey(e);

		if (key[0] == 27) {  // escape
			that.window.close.trigger('click');
		}

		return false;
	}

	openUrl (href) {
		this.open();
		var that = this;

		$.ajax({
			url: href,
			dataType: that.dataType == DataTypes.JSON ? 'json' : null,
			data: that.requestData,
			success: function (data) {
				var html = '';

				if (that.dataType == DataTypes.JSON) {
					var resp = new AjaxResponse(data);

					if (resp.html) {
						html = resp.html;
					}

					if (resp.userMessages) {
						// na mobilu mozno predelat na zobrazeni pres invia.showFixedMessage (zobrazi UM na spodnim okraji obrazovky)
						var msgHtml = '';

						$.each(resp.userMessages, function () {
							msgHtml += createMessage(this.type, this.text);
						});

						html = msgHtml + html;
					}
				} else {
					if (typeof data != 'string') {
						throw new Error('Response should be string (HTML)');
					}

					html = data;
				}

				that.window.content.html(html);
				var ajaxForm = null;

				if (that.ajaxFormProp) {
					var $ajaxFormElem = that.window.content.find(that.ajaxFormProp.selector);

					if ($ajaxFormElem.length == 0) {
						throw new Error('Form element not found (selector "' + that.ajaxFormProp.selector + '")');
					}

					// kdybych neudelal kopii objektu options, tak se tam pri 1. zobrazeni popupu ulozi target a pri 2. a dalsim
					// volani uz tam zustal (neexisujici objekt) misto toho, aby se tam nastavil ten aktualne vytvoreny
					var origOptions = that.ajaxFormProp.options || {};
					var options = $.extend({}, origOptions);

					// defaultni target je popup okno
					if (typeof options.target == 'undefined' && typeof options.replaceTarget == 'undefined') {
						options.target = that.window.content;
						options.replaceTarget = false;
					}

					ajaxForm = new AjaxForm($ajaxFormElem, options);
					ajaxForm.setPopup(that);
				}

				that.handleOnLoad(data, ajaxForm);
			},
			error: captureAjaxError,
		});
	}

	handleOnOpen () {
		if (typeof this.onOpen == 'function') {
			this.onOpen.call(this, this.window.elem);
		}
	}

	// onload funkce - pro zpětné volání
	handleOnLoad (data, ajaxForm) {
		// Inicializuje se pri contentload udalosti v selectBoxes.js
		// if (typeof $.fn.selectBox == 'function') {
		// 	this.window.content.find('select').selectBox();
		// }

		// Inicializuje se pri contentload udalosti v selectBoxes.js
		// this.window.content.find('form[data-antispam="1"]').each(function () {
		// 	initAntiSpamControl($(this));
		// });

		if (typeof this.onLoad == 'function') {
			this.onLoad.call(this, this.window.elem, data, ajaxForm);
		}

		this.window.content.trigger('contentload');

		this.hideLoader();
	}

	showLoader () {
		var height = this.window.content.height();
		this.window.content.hide();
		this.window.elem.addClass('loading');
	}

	hideLoader () {
		this.window.content.show();
		this.window.elem.removeClass('loading');
	}

	handleOnClose () {
		if (typeof this.onClose == 'function') {
			this.onClose.call(this, this.window.elem);
		}
	}

	getKey (e) {
		var keycode;

		if (!e) {
			var e = window.event;
		}

		if (e.keyCode) {
			keycode = e.keyCode;
		} else if (e.which) {
			keycode = e.which;
		}

		var key = String.fromCharCode(keycode).toLowerCase();
		return [keycode, key];
	}

	prepareAjaxForm (options, selector) {
		this.ajaxFormProp = {
			selector: selector || 'form',
			options: options || {},
		};
	}
}

export default PopupWindow;
